module.exports = __webpack_public_path__ + "img/pålestikk_tredd_1.1f80ad0e.jpg";